var _rect, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    fill: "#7c2d12",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 64,
    x2: 216,
    y2: 64,
    fill: "none",
    stroke: "#7c2d12",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 128,
    x2: 216,
    y2: 128,
    fill: "none",
    stroke: "#7c2d12",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 192,
    x2: 144,
    y2: 192,
    fill: "none",
    stroke: "#7c2d12",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 184,
    y1: 192,
    x2: 232,
    y2: 192,
    fill: "none",
    stroke: "#7c2d12",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 208,
    y1: 168,
    x2: 208,
    y2: 216,
    fill: "none",
    stroke: "#7c2d12",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPlus);
export default __webpack_public_path__ + "static/media/list-plus.18dddcfbf921d5e00bb86472e08681ac.svg";
export { ForwardRef as ReactComponent };